import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { ProfilEmprunteurOptionsEmprunteur } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(
    entity: ProfilEmprunteurOptionsEmprunteur & {
      profilEmprunteur: any;
    },
    option,
  ) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userFirstName: [entity.userFirstName],
        userLastName: [entity.userLastName],
        profilEmprunteur: this.formBuilder.group({
          optionIPP: [
            _.isBoolean(entity?.profilEmprunteur?.optionIPP)
              ? entity?.profilEmprunteur?.optionIPP
              : null,
            Validators.required,
          ],
          optionDosPsy: [
            _.isBoolean(entity?.profilEmprunteur?.optionDosPsy)
              ? entity?.profilEmprunteur?.optionDosPsy
              : null,
            Validators.required,
          ],
          loiLemoine: [
            _.isBoolean(entity?.profilEmprunteur?.loiLemoine)
              ? entity?.profilEmprunteur?.loiLemoine
              : null,
            Validators.required,
          ],
        }),
      },
      options,
    );
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
